<template lang="pug">
transition(name="fade")
  .material-window(v-if="isShowMaterial" @touchmove="onTouchMove")
    .background
    .material-content
      p.close(@click="hideMenu") close
      ul.materials
        li(v-for="(material, name) in materials" :key="name" @click="onSelect(name)")
          img(:src="material.thumbnail")
          p {{name}}

</template>

<script>
import { mapState, mapMutations } from 'Vuex'
import MaterialList from '~/js/modelviewer/materiallist'

export default {
  props:{},
  components: {},
  computed: {
     ...mapState('material', {isShowMaterial: 'isShowMaterial', materialListName: 'materialListName'}),
     materials(){

       // 設定されてないない場合は''になるので空を返す
       if(this.materialListName == '')
          return {};
       return this.materialList[`${this.materialListName}`];
     }
  },
  methods: {
    ...mapMutations('material', {hideMenu: 'hide'}),
   onTouchMove(e){
      e.preventDefault();
    },
    onSelect(name){
      this.hideMenu();
      this.$viewer.changeMaterial(this.materialListName, name);
    }
  },
  created () {
    
  },
  mounted () {
    
  },
  data () {
    return {
      materialList: MaterialList
    }
  },
}
</script>

<style lang="stylus" scoped>
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;
.material-window
  position fixed
  bottom 0
  left 0
  z-index 100
  width 100%
  height auto
  .background
    width 100%
    height 100%
    background-color rgba(0, 0, 0, 0.5)
    position absolute
    top 0
    left 0
    z-index 0
  .material-content
    padding 20px 0px 15px
    width 100%
    position relative
    z-index 1
    .close
      color white
      position absolute
      top 30px
      right 30px
      border white 1px solid
      cursor pointer
      width 60px
      height 30px
      text-align center
      line-height 30px
    
    ul
      flex-wrap wrap
      display flex
    li
      height: 100px;
      width: 100px;
      border-radius: 50%;
      margin-left 20px
      cursor pointer
      margin-bottom 20px 
      p
        color white
      img
        display block
        width 100px
    li.red
      background-color: #ff0000;
    li.green
      background-color: #00ff00;
    li.blue
      background-color: #0000ff
   

</style>
